

import { Component, OnInit } from '@angular/core';
import { DataTable, DataTableResource, DataTableTranslations } from 'angular7-data-table';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbModalRef, NgbModalOptions, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { EventService } from "../event.service"
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from "sweetalert2";
import { ConfirmationComponent } from 'src/app/common/components/confirmation/confirmation.component';
import * as moment from "moment";

@Component({
  selector: 'app-view-event',
  templateUrl: './view-event.component.html',
  styleUrls: ['./view-event.component.css']
})

export class ViewEventComponent implements OnInit {

  private modalRef: NgbModalRef;

  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false
  };
  statusList: Array<object> = [
    { id: "active", name: "Active" },
    { id: "blocked", name: "Blocked" }
  ];
  closeResult: string;
  statusFormSubmitted: boolean = false;
  planDetails: any;
  statusForm: FormGroup;
  featureList = [];
  finalFeatureList = [];
  coursePlanList = [];
  userList = [];
  temp: any;
  feature: string;
  plancount: number;
  plan_id: any;
    pageLimit: number = 100 ;
  offset: number = 0 ;
  rowCount:number = 100 ;
  constructor(private formBuilder: FormBuilder, private modalService: NgbModal, private EventService: EventService, private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.spinner.show();
    this.getplan();
    // this.startLoadingSpinner();
  }

  startLoadingSpinner() {

    setTimeout(function () {
      this.spinner.hide();
    }.bind(this), 3000);
  }

  labels = <DataTableTranslations>{
    loadingText: 'Your {title} table is reloading - and this is my custom message.',
    paginationText: 'Your table displays {from} to {to} of {total} rows.'
  };
  prepareUpdateStatusForm() {
    this.statusForm = this.formBuilder.group({
      newStatus: ["", [Validators.required]]
    });
  }
  getplan() {
    let query ="sortType=upcoming";
    this.EventService.getEventList(query).subscribe(res => {
      this.spinner.show(); 

      if ((res["message"] = "Success")) {
        this.coursePlanList = res.data.eventList;
        this.coursePlanList.forEach(element => {
          element['TimeDisp'] = this.tConvert(element['time']);
          element["eventEpoch"] = moment(element["eventEpoch"]*1000).format("ll");
          element["insertDate"] = moment(element["insertDate"]).format("ll");
        });
        this.plancount = this.coursePlanList.length;
        this.spinner.hide();
      } else {
        this.spinner.hide();
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });
      }
    }, err => {
      this.spinner.hide();
    });

  }
  swalImage (image) {
    Swal.fire({
      imageUrl: image,
      imageWidth: 400,
      imageHeight: 400,
    })
  }
  openwebView(value) {
    let index = value.indexOf("http");
    let url = "";
    if (index == -1) {
      url = "http://" + value;
    } else {
      url = value;
    }
    window.open(url, "_blank");
  }
   tConvert (time) {
    // Check correct time format and split into components
    time = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
  
    if (time.length > 1) { // If time format correct
      time = time.slice (1);  // Remove full string match value
      time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join (''); // return adjusted time or original string
  }
  



  updateUserStatus(test) {
    this.statusFormSubmitted = true;
    if (this.statusForm.valid) {
      this.spinner.show();
      let finalObj = {
        coursePlanId: this.planDetails["coursePlanId"],
        status: this.statusForm.controls.newStatus.value
      };
      this.EventService.EditEvent(finalObj).subscribe(data => {
        this.spinner.hide();

        if ((data["message"] = "Success")) {
          Swal.fire("Success", "Event status updated successfully!", "success");
          this.modalRef.close();
          this.getplan();
        } else {
          Swal.fire({
            type: "error",
            title: "Error",
            text: data.msg
          });
        }
      });
    }
  }


  updateUserStatusModal(row, content, btn) {
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();

    this.planDetails = row;
    this.statusFormSubmitted = false;
    this.prepareUpdateStatusForm();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  updateUserStatusModal1(row, content, btn) {

    this.plan_id = row.eventId;
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();

    this.planDetails = row;
    this.statusFormSubmitted = false;
    this.prepareUpdateStatusForm();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  updateUserStatusModal2(row, content, btn) {
      this.spinner.show();
    this.EventService.getSavedEventById(row).subscribe(data => {
      this.spinner.hide();

      if ((data["message"] = "Success")) {
        this.userList = data.data.userList;
        btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
       
      } else {
        Swal.fire({
          type: "error",
          title: "Error",
          text: data.msg
        });
      }
    });
    
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  confirmDeleteRecord(record: any) {

    let modalRef = this.modalService.open(ConfirmationComponent, this.modelOptions);
    modalRef.componentInstance.content = "Are you sure you want to delete this record?";
    modalRef.componentInstance.leftButton = "No";
    modalRef.componentInstance.rightButton = "Yes";
    modalRef.result.then(
      (data: any) => {
        if (data == "yes") {
          this.deleteRecord(record);
        }
      },
      (reason: any) => { }
    );
  }

  deleteStatusModal(row, content, btn) {
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();


    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }


  deleteRecord(record: any) {

    this.spinner.show();

    this.EventService.deleteEvent(this.plan_id).subscribe(res => {
      if ((res["status"] = "Success")) {
        Swal.fire("Success", "Event Deleted successfully!", "success");
        this.modalRef.close();
        this.spinner.hide();
        this.getplan();
      } else {
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });

      }
    });
    this.spinner.hide();

  }
}
